import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["onKeydown"]
const _hoisted_2 = {
  key: 0,
  class: "list"
}
const _hoisted_3 = ["value", "textContent", "onClick"]

import { computed, onMounted, PropType, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Autosuggest',
  props: {
  modelValue: {
    required: true,
    default: '',
  },
  items: {
    type: Array as PropType<string[]>,
    required: true,
  },
  focus: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update:modelValue', 'changed'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

// the selected item, used to show label on blur
const item = ref<string>(props.modelValue);

const input = ref<any>(null);
const open = ref<boolean>(false);
const focusIndex = ref<number>(0);

const itemsFiltered = computed<string[]>(() => {
  return props.items.filter((v) =>
    v.toLowerCase().includes(item.value.toLowerCase()),
  );
});

const openClass = computed<string>(() =>
  open.value && item.value && itemsFiltered.value.length
    ? 'field-auto-suggest-open'
    : '',
);

const update = () => {
  emit('update:modelValue', item.value);
};

const toggleList = () => {
  open.value = !open.value;
  focusIndex.value =
    open.value && item.value
      ? itemsFiltered.value.findIndex((i) => i === item.value)
      : -1;
};

const close = () => {
  open.value = false;
};

const blur = () => {
  // prevent the blur from closing before a choose function has had time to work
  setTimeout(() => close(), 250);
};

const choose = () => {
  if (open.value) {
    chooseItem(focusIndex.value);
  }
};

const chooseItem = (index: number) => {
  const i = itemsFiltered.value[index];
  item.value = i;

  emit('changed', i);
  update();
  close();
};

const focusClass = (index: number) => {
  return index === focusIndex.value ? 'choice-focus' : '';
};

const next = () => {
  if (!open.value) {
    toggleList();
    return;
  }
  focusIndex.value++;
  if (focusIndex.value > itemsFiltered.value.length - 1) {
    focusIndex.value = 0;
  }
};

const previous = () => {
  focusIndex.value--;
  if (focusIndex.value < 0) {
    focusIndex.value = itemsFiltered.value.length - 1;
  }
};

onMounted(() => {
  if (props.focus) {
    input.value.focus();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass('field-auto-suggest ' + openClass.value)
  }, [
    _withDirectives(_createElementVNode("input", {
      class: "visible",
      type: "text",
      ref_key: "input",
      ref: input,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((item).value = $event)),
      onFocus: _cache[1] || (_cache[1] = ($event: any) => (open.value = true)),
      onChange: update,
      onBlur: blur,
      onKeydown: [
        _withKeys(_withModifiers(close, ["prevent"]), ["esc"]),
        _withKeys(_withModifiers(choose, ["prevent"]), ["enter"]),
        _withKeys(_withModifiers(previous, ["prevent"]), ["up"]),
        _withKeys(_withModifiers(next, ["prevent"]), ["down"])
      ]
    }, null, 40, _hoisted_1), [
      [_vModelText, item.value]
    ]),
    (open.value && itemsFiltered.value.length && item.value.length > 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemsFiltered.value, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              class: _normalizeClass(focusClass(index)),
              value: item,
              textContent: _toDisplayString(item),
              key: item,
              onClick: _withModifiers(($event: any) => (chooseItem(index)), ["stop","prevent"])
            }, null, 10, _hoisted_3))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})